import formulaColor from './formulaColor'
import color from 'css-color-function'

export default function colorConvert (primaryColor) {
  let colors = {'--primary': primaryColor}
  Object.keys(formulaColor).forEach(key => {
    const value = formulaColor[key].replace(/primary/g, primaryColor)
    colors[`--${key}`] = color.convert(value)
  })
  return colors
}



// WEBPACK FOOTER //
// ./src/plugins/theme/colorConvert.js